import React, { useEffect, useState } from "react"
import "./courses.css"
import { online } from "../../dummydata"
import api from "../api"
import { BASE_URL } from "../common/constants"

const OnlineCourses = () => {
  const [courses,setCourses]=useState([])

    const getCourses = async () => {
    try{
    const resp = await api.get(`/api/v1/courses`);
    setCourses(resp?.data?.rows)  
    }catch(error){
      console.log("error",error)
    }
  }

  useEffect(()=>{
    getCourses()
  },[])
  return (
    <>  
      <section className='online'>
        <div className='container'>
          {/* <Heading subtitle='COURSES' title='Browse Our Online Courses' /> */}
          <div className='content grid3'>
            {/* {online.map((val) => (
              <div className='box'>
                <div className='img'>
                  <img src={val.cover} alt="cover" />
                  <img src={val.hoverCover} alt='' className='show' />
                </div>
                <h1>{val.courseName}</h1>
                <span>{val.course}</span>
              </div>
            ))} */}
            {courses.map((val) => (
              <div className='box'>
                <div className='img'>
                  <img src={ BASE_URL +
                          '/' +val.logo} alt="cover" />
                  <img src={ BASE_URL +
                          '/' +val.logo} alt='' className='show' />
                </div>
                <h1>{val.name}</h1>
                {/* <span>{val.course}</span> */}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default OnlineCourses
